
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { UnsplashImageSearch } from "@/components/UnsplashImageSearch";
import { Image } from 'lucide-react';

interface UnsplashImageData {
  url: string;
  description: string;
  attribution: {
    photographerName: string;
    photographerUsername: string;
    photographerUrl: string;
    unsplashUrl: string;
  };
  width: number;
  height: number;
}

interface UnsplashImagePickerModalProps {
  onImageSelect: (image: UnsplashImageData) => void;
  buttonLabel?: string;
}

export function UnsplashImagePickerModal({ 
  onImageSelect, 
  buttonLabel = "Search Unsplash Images" 
}: UnsplashImagePickerModalProps) {
  const [open, setOpen] = useState(false);

  const handleImageSelected = (image: UnsplashImageData) => {
    onImageSelect(image);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="gap-2">
          <Image className="h-4 w-4" />
          {buttonLabel}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[800px] max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Search Unsplash Images</DialogTitle>
        </DialogHeader>
        <UnsplashImageSearch onImageSelect={handleImageSelected} />
      </DialogContent>
    </Dialog>
  );
}
